export const hiivesKeys = {
  all: ["hiives"] as const,
  location: () => [...hiivesKeys.all, "location"] as const,
  upcomingEvents: (locationKey?: string | null) =>
    [...hiivesKeys.all, "upcoming-events", locationKey ?? "none"] as const,
  suggestedPeople: () => [...hiivesKeys.all, "suggested-people"] as const,
  activityPeople: (activityId?: string | null) =>
    [...hiivesKeys.all, "activity-people", activityId ?? "default"] as const,
  nearbyHiives: (locationKey?: string | null) =>
    [...hiivesKeys.all, "nearby-hiives", locationKey ?? "none"] as const,
  mapEntities: (viewportKey?: string | null) =>
    [...hiivesKeys.all, "map-entities", viewportKey ?? "all"] as const,
  detailAll: () => [...hiivesKeys.all, "detail"] as const,
  detailRequestContext: () =>
    [...hiivesKeys.detailAll(), "request-context"] as const,
  detailPage: (hiiveSlug: string) =>
    [...hiivesKeys.detailAll(), "page", hiiveSlug] as const,
  eventAll: () => [...hiivesKeys.all, "event"] as const,
  eventDetailPage: (hiiveSlug: string, eventSlug: string) =>
    [...hiivesKeys.eventAll(), "detail", hiiveSlug, eventSlug] as const,
  eventBookingPage: (hiiveSlug: string, eventSlug: string) =>
    [...hiivesKeys.eventAll(), "booking", hiiveSlug, eventSlug] as const,
  joinAll: () => [...hiivesKeys.all, "join"] as const,
  /**
   * `forEventSlug` is part of the key, not a detail hanging off it: the same
   * hiive rendered with and without an event context is two different payloads
   * (different banner, different highlight), and collapsing them into one entry
   * makes the highlight vanish on the second visit.
   */
  joinPage: (hiiveSlug: string, forEventSlug: string | null = null) =>
    [...hiivesKeys.joinAll(), "page", hiiveSlug, forEventSlug] as const,
};
